import axios from 'axios'
import config from './config'
import { getTokenData, isSessionExpired, sessionExpiredLogout } from './session'

const api = axios.create({ baseURL: config.url })

api.interceptors.request.use(async (reqConfig) => {
  const { access_token: token } = getTokenData()

  if (token) {
    if (isSessionExpired()) {
      sessionExpiredLogout()
      return new Promise(() => {})
    }
    reqConfig.headers.set('Authorization', `Bearer ${token}`)
  }

  return reqConfig
})

export default api
